import { gboReservationPath, gmaPreSelectedReservationPath, gmaInitiateRequestPath } from './session';

export const reservationContractDetailsPath = [...gboReservationPath, 'contract_details'];
export const gmaPreSelectedReservationContractDetailsPath = [...gmaPreSelectedReservationPath, 'contract_details'];
export const gmaInitiateContractDetailsPath = [...gmaInitiateRequestPath, 'contract_details'];
export const gmaInitiateContractNumberPath = [...gmaInitiateContractDetailsPath, 'contract_number'];
export const gmaPreSelectedReservationCouponsPath = [...gmaPreSelectedReservationPath, 'coupons'];
export const gmaPreSelectedReservationBillingAccountPath = [...gmaPreSelectedReservationPath, 'billing_account'];
